import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n";

import { App } from "./App";
import { Providers } from "./Providers";
import { enableMocking } from "./mocks";

import "normalize.css";
import "@radix-ui/themes/styles.css";
import "./themes/palette.css";
import "./themes/global.css";

dayjs.extend(duration);

const scheduleNonCriticalStyles = () => {
  if (typeof window === "undefined") return;

  let loaded = false;
  const loadRemixIcons = () => {
    if (loaded) return;
    loaded = true;
    void import("./themes/remixicon-subset").then((module) => module.loadRemixiconSubset());
  };

  // Load icon font after first paint/idle, but keep interaction fallback.
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(loadRemixIcons, { timeout: 2000 });
  } else {
    setTimeout(loadRemixIcons, 1200);
  }

  window.addEventListener("pointerdown", loadRemixIcons, { once: true });
  window.addEventListener("keydown", loadRemixIcons, { once: true });
};

enableMocking().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

  root.render(
    <React.StrictMode>
      <Providers>
        <App />
      </Providers>
    </React.StrictMode>,
  );

  scheduleNonCriticalStyles();
});
